import { Pages } from '@/components'

function App() {
  return <Pages.HomePage />
}

export default App
